import { archiverUrl, fetchWithAuthorization } from '../../helpers/utils';

const TransactionApi = {
    fetchContention: (timeRangeQS: string, instanceId: number): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl()}/transaction/contention?${timeRangeQS}&id=${instanceId}&sort=contentionduration+desc`),
};

export default TransactionApi;
